import { createApi } from '@reduxjs/toolkit/query/react';

import { baseQueryWithReauth } from '@app/store/utils/baseQueryWithReauth';
import { ApiResponse, extractData } from '@app/store/utils/common';
import { invalidateOnSuccess } from '@app/shared/utils/common';
import { updateBalance } from '@app/store/utils/cacheUpdate';
import { DailyRewardStatus, DailyRewardTagTypes } from './dailyRewardTypes';
import { BalanceActionType, PriceType } from '@app/shared/types/common';
import { log } from '@/app/shared/utils/logger';

export const dailyRewardApi = createApi({
  reducerPath: 'dailyRewardApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: Object.values(DailyRewardTagTypes),
  endpoints: (builder) => ({
    getDailyRewardStatus: builder.query<DailyRewardStatus | null, void>({
      query: () => '/users/daily-reward',
      transformResponse: extractData,
      providesTags: [DailyRewardTagTypes.DAILY_REWARD_STATUS],
    }),
    claimDailyReward: builder.mutation<ApiResponse<void>, number>({
      query: () => ({
        url: '/users/daily-reward',
        method: 'POST',
      }),
      invalidatesTags: invalidateOnSuccess([DailyRewardTagTypes.DAILY_REWARD_STATUS]),
      onQueryStarted(reward, { dispatch }) {
        try {
          updateBalance(PriceType.COOKIE, BalanceActionType.INCREASE, reward, dispatch);
        } catch (error: unknown) {
          void log({ level: 'error', message: 'claimDailyReward error', error });
        }
      },
    }),
  }),
});

export const { useGetDailyRewardStatusQuery, useClaimDailyRewardMutation } = dailyRewardApi;
